import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { EventRecord, UpdateEventRequest } from "../EventRecord";

import { eventQueryKeys } from "./eventQueryKeys";

interface UseUpdateEventVariables {
  id: string;
  requestBody: UpdateEventRequest;
}

export function useUpdateEvent() {
  const { events } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<EventRecord, Error, UseUpdateEventVariables>({
    mutationFn: ({ id, requestBody }) => {
      return events.updateEvent(id, requestBody);
    },
    onSuccess: (updatedEvent) => {
      const orgId = updatedEvent.org_id;
      queryClient.setQueryData(
        eventQueryKeys.detail(orgId, updatedEvent.event_id),
        updatedEvent,
      );
      void queryClient.invalidateQueries({
        queryKey: eventQueryKeys.lists(orgId),
      });
      void queryClient.invalidateQueries({
        queryKey: eventQueryKeys.forWorkspaces(orgId),
      });
      // An update may add a tag the org hasn't seen
      void queryClient.invalidateQueries({
        queryKey: eventQueryKeys.orgTags(orgId),
      });
    },
  });
}
